import { error as notificationError, success as notificationSuccess } from 'react-notification-system-redux';
import { getErrors } from './ApolloGraphqlUtil';

export const buildDefaultNotification = message => ({
  message,
  position: 'tr',
  autoDismiss: 5,
});

export const dispatchGraphqlErrors = (dispatch, graphqlResponse) => {
  const errors = getErrors(graphqlResponse);
  if (errors == null) {
    return;
  }
  for (let i = 0; i < errors.length; i += 1) {
    const notification = buildDefaultNotification(errors[i].message);
    dispatch(notificationError(notification));
  }
};

export const dispatchErrors = (dispatch, errors) => {
  if (errors == null) {
    return;
  }
  for (let i = 0; i < errors.length; i += 1) {
    const notification = buildDefaultNotification(errors[i].message);
    dispatch(notificationError(notification));
  }
};

export const dispatchDefaultSuccess = (dispatch, message) => {
  const notification = buildDefaultNotification(message);
  dispatch(notificationSuccess(notification));
};

export const growlErrorsWithMessage = (growl, message) => {
  growl.show({ severity: 'error', detail: message, sticky: true });
};

export const growlErrors = (growl, graphqlResponse) => {
  const errors = getErrors(graphqlResponse);
  if (errors == null) {
    return;
  }
  for (let i = 0; i < errors.length; i += 1) {
    growl.show({ severity: 'error', detail: errors[i].message, sticky: true });
  }
};

export const growlWarning = (growl, message = null) => {
  if (!message) {
    growl.show({ severity: 'warn', detail: 'Warning!', sticky: true });
  } else {
    growl.show({ severity: 'warn', detail: message, sticky: true });
  }
};

export const growlActionSuccess = (growl, message = null) => {
  if (!message) {
    growl.show({ severity: 'success', detail: 'Success!' });
  } else {
    growl.show({ severity: 'success', detail: message });
  }
};
